import { getStoredAdminToken } from '../lib/auth'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export async function apiRequest<T>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`
  const token = getStoredAdminToken()

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options?.headers,
    },
  })

  if (response.status === 401) {
    window.dispatchEvent(new Event('mate-admin-unauthorized'))
    throw new Error('Unauthorized')
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({
      detail: `HTTP ${response.status}: ${response.statusText}`,
    }))
    throw new Error(error.detail || 'Request failed')
  }

  return response.json()
}

// User API
export const usersApi = {
  list: () => apiRequest<{ users: any[] }>('/api/admin/users'),
  get: (id: string) => apiRequest(`/api/admin/users/${id}`),
  create: (data: { email: string; name?: string }) =>
    apiRequest('/api/admin/users', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  delete: (id: string) =>
    apiRequest(`/api/admin/users/${id}`, { method: 'DELETE' }),
}

// Session API
export const sessionsApi = {
  listForUser: (userId: string) =>
    apiRequest<{ sessions: any[] }>(`/api/admin/users/${userId}/sessions`),
  getMessages: (sessionId: string) =>
    apiRequest<{ messages: any[] }>(`/api/admin/sessions/${sessionId}/messages`),
}

// Add more API functions as backend endpoints are created
